var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay-preloader"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#ff0000"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }